import React, { Component } from "react";
import * as Constants from "../../../../common/Global/constants";
import { SearchSpan, DialogSaveButton, TableCheckBox, TableIcon } from "../../../../common/Global/globalStyles.style";
import FilterDropDown from "../../../../common/DropdownMenus/FilterDropdown";
import Pagination from "../../../../common/Global/pagination";
import { getLocalStorageVariables, ifEmptyReturnEmptyStr, isEmptyVariable, sortTable, truncateString, isEmptyArray, handleTokenExpiry } from "../../../../common/Global/commonFunctions";
import { Modal } from "react-bootstrap";
import RegularDropdown from "../../../../common/DropdownMenus/RegularDropdown";
import DocumentSamplesListLayout from "./listCopyDocumentSample";
import DocumentERPListLayout from "./listCopyDocumentERPMaster";
import AlertDialog from "../../../../common/AlertDialog";

let userDetails = getLocalStorageVariables();

const sortShortName = "shortName";
const sortName = "name";
const sortDescription = "description";
const sortMasterType = "masterType";
const sortDeptName = "departmentName";

const departmentDropdownDefaultValue = "Select Department";
const departmentFilterDropdownDefaultValue = "All";

const activeStatus="Active";
const inActiveStatus="Inactive";
const underReviewStatus="Under Review";
const requestChangeCheckText="Request Change";

class DocumentSampleList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			componentDidMountFlag: false,
			apiSearchKey: "",
			searchkey: "",
			currentPageNo: 1,
			showLoader: false,
			resultSize: Constants.RESULT_SIZE,
			totalCount: 0,
			datalist: [],
			resultSizePlaceholder: Constants.RESULT_SIZE,
			resultSizeArr: JSON.parse(JSON.stringify(Constants.RESULT_SIZE_DD_ARR)),
			sort: "",
			sortDir: "",

			selectedId: "",

			departmentArr: [],
			selectedDepartmentName: departmentDropdownDefaultValue,
			selectedDepartmentId: "",
			formErrors: {},

			showTableFlag: false,

			showDocumentListing: true,
			showDocumentSamplesListing: false,
			showDocumentERPListing: false,
			selectedDocumentId: "",
			selectedDocumentName: "",

			showDetailsDialog: false,
			selectedItem: "",
			showAlertDialogInfo:false,
            alertDialogMessageInfo:""
		};
		this.masterTypeFilterArr = [];
		userDetails = getLocalStorageVariables();
	}
	componentDidUpdate(prevProps) {
		if (JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showCopyDocumentDialog) {
			
			this.setState({
				showLoader: true,
	
				showTableFlag: false,
				searchkey: "",
				currentPageNo: 1,
				resultSize: JSON.parse(JSON.stringify(Constants.RESULT_SIZE)),
				resultSizeArr: JSON.parse(JSON.stringify(Constants.RESULT_SIZE_DD_ARR)),
				sort: "",
				sortDir: "",
				resultSizePlaceholder: Constants.RESULT_SIZE ,
			},()=>{
				this.getInitData();
			});
		}
	}

	handleChangeSearch = (e) => {
		const { name, value } = e.target;

		this.setState({
			[name]: value,
		});
	};

	onSearchIconClick = () => {
		this.setState(
			{
				currentPageNo: 1,
			},
			() => {
				this.getDocumentMastersList();
			}
		);
	};

	onEnterBtnPress = (e) => {
		var code = e.keyCode || e.which;
		if (code === 13) {
			this.setState(
				{
					currentPageNo: 1,
				},
				() => {
					this.getDocumentMastersList();
				}
			);
		}
	};
	sortTableLocal = (sortColumn) => {
		let sortObj = sortTable(sortColumn, this.state.sort, this.state.sortDir);

		this.setState(
			{
				sort: sortObj.sortTemp,
				sortDir: sortObj.sortDirTemp,
			},
			() => {
				this.getDocumentMastersList();
			}
		);
	};

	handleStopPropagation = (e) => {
        e.stopPropagation();
    }

	handleShowDocumentSamplesListing = (document, e) => {
		e.stopPropagation();
		this.setState({
			selectedDocumentId: document.documentId,
			selectedDocumentName: document.name,
			showDocumentListing: false,
			showDocumentSamplesListing: true,
			showDocumentERPListing: false,
		});
	};

	handleShowDocumentERPListing = (document, e) => {
		e.stopPropagation();
		this.setState({
			selectedDocumentId: document.documentId,
			selectedDocumentName: document.name,
			showDocumentListing: false,
			showDocumentSamplesListing: false,
			showDocumentERPListing: true,
		});
	};

	handleBackBtnClickFromSamplesandERP = () => {
		this.setState({
			selectedDocumentId: "",
			selectedDocumentName: "",
			showDocumentListing: true,
			showDocumentSamplesListing: false,
			showDocumentERPListing: false,
		});
	};

	handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

	resultSizeDropdownClick = (item, selectedIndex) => {
		let tempArr = this.state.resultSizeArr;
		let placeholder = "";

		for (const [i, value] of tempArr.entries()) {
			if (i === selectedIndex) {
				tempArr[i].isSelected = true;
				placeholder = value.label ;
			} else {
				tempArr[i].isSelected = false;
			}
		}

		this.setState(
			{
				resultSizeArr: tempArr,
				resultSize: item.label,
				resultSizePlaceholder: placeholder,
			},
			() => {
				this.getDocumentMastersList();
			}
		);
	};

	deptFilterDropdownClick = (item, selectedIndex) => {
		let placeholder = "";
		let id = "";
		let filterDeptArr = this.state.filterDeptArr;

		for (const [i, value] of filterDeptArr.entries()) {
			if (i === selectedIndex) {
				filterDeptArr[i].isSelected = true;
				placeholder = value.deptName;
				id = value.departmentId;
			} else {
				filterDeptArr[i].isSelected = false;
			}
		}

		this.setState(
			{
				currentPageNo: 1,
				selectedFilterDepartmentName: placeholder,
				selectedFilterDepartmentId: id,
			},
			() => {
				this.getDocumentMastersList();
			}
		);
	};

	handleSelection = (e) => {
		e.stopPropagation();
		let selectedId = "";
		let index = e.target.name;

		if (this.state.selectedId !== this.state.datalist[index].documentId) {
			selectedId = this.state.datalist[index].documentId;
		}
		this.setState({
			selectedId: selectedId,
		});
	};

	deptDropdownClick = (item) => {
		let FormErrorsTemp = this.state.formErrors;

		if (this.state.submitClickedAtleastOnce) {
			FormErrorsTemp["deparment"] = "";
		}

		this.setState(
			{
				currentPageNo: 1,
				selectedDepartmentName: item.name,
				selectedDepartmentId: item.departmentId,
				formErrors: FormErrorsTemp,
			},
			() => {
				this.getInitDataMultiple();
			}
		);
	};

	handleDetailsDialogClose = () => {
		this.setState({
			showDetailsDialog: false,
			selectedItem: "",
		});
	};

	handleDetailsDialogShow = (item) => {
		this.setState({
			showDetailsDialog: true,
			selectedItem: item,
		});
	};

	/*****************************API*********************************/

	getInitData = () => {
		

		Promise.all([
			fetch(Constants.GetDocumentMasterCreateMasterData, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams({
					email: userDetails.email,
					accessToken: userDetails.accessToken,
				}),
			}),
			fetch(Constants.GetCopyDocumentMasterData, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams({
					email: userDetails.email,
					accessToken: userDetails.accessToken,
					pageNo: this.state.currentPageNo,
					search: this.state.searchkey,
					resultsize: this.state.resultSize,
					sort: this.state.sort,
					sortDir: this.state.sortDir,
					// departmentOnly: this.state.deptOnly,
				}),
			}),
		])
			.then(([masterRes, generalRes]) => {
				return Promise.all([masterRes.json(), generalRes.json()]);
			})
			.then(([masterRes, generalRes]) => {
				let datalistTemp = [];
				let totalCountTemp = 0;

				let deptTemp = [];
				let targetFilterDeptTemp = [];

				if(handleTokenExpiry(masterRes.responseCode)) return;
				else if (masterRes.responseCode === Constants.CODE_SUCCESS) {
					deptTemp = masterRes.data.departments;
				} else {
				}
				if(handleTokenExpiry(generalRes.responseCode)) return;
				else if (generalRes.responseCode === Constants.CODE_SUCCESS) {
					datalistTemp = generalRes.data.result;
					targetFilterDeptTemp = generalRes.data.departments;

					totalCountTemp = generalRes.data.count;
				} else {
					datalistTemp = [];
				}

				//if user belongs to single dept then dont show the dropdown
				let selectedDepartmentId = "";
				let selectedDepartmentName = departmentDropdownDefaultValue;
				let showTableFlag = false;
				if (!isEmptyArray(deptTemp) && deptTemp.length === 1) {
					selectedDepartmentId = deptTemp[0].departmentId;
					selectedDepartmentName = deptTemp[0].name;

					showTableFlag = true;
				}

				//Filter Dept array
				let filterDeptArr = [];
				let selectedFilterDepartmentId = "-100";
				let selectedFilterDepartmentName = "All";
				if (!isEmptyArray(targetFilterDeptTemp) && targetFilterDeptTemp.length === 1) {
				} else {
					let obj = {
						departmentId: "-100",
						deptName: departmentFilterDropdownDefaultValue,
						isSelected: true,
					};
					filterDeptArr = [...targetFilterDeptTemp];
					filterDeptArr.splice(0, 0, obj);
				}

				this.setState({
					componentDidMountFlag: true,
					showLoader: false,

					datalist: datalistTemp,
					totalCount: totalCountTemp,

					departmentArr: deptTemp,

					filterDeptArr: filterDeptArr,
					selectedFilterDepartmentId: selectedFilterDepartmentId,
					selectedFilterDepartmentName: selectedFilterDepartmentName,

					selectedDepartmentId: selectedDepartmentId,
					selectedDepartmentName: selectedDepartmentName,
					formErrors: {},
					selectedId: "",

					showTableFlag: showTableFlag,

					showDocumentListing: true,
					showDocumentSamplesListing: false,
					showDocumentERPListing: false,
					selectedDocumentId: "",
					selectedDocumentName: "",
				});
			});
	};

	getInitDataMultiple = () => {
		this.setState({
			showLoader: true,
			showTableFlag: false,
		});

		let postParam = {
			email: userDetails.email,
			accessToken: userDetails.accessToken,
			pageNo: this.state.currentPageNo,
			search: this.state.searchkey,
			resultsize: this.state.resultSize,
			// status: this.state.status,
			sort: this.state.sort,
			sortDir: this.state.sortDir,
			//TODO
			status: "Active",
		};

		if (this.state.departmentArr.length > 1 && this.state.selectedDepartmentName !== departmentFilterDropdownDefaultValue) {
			// exclude this department
			postParam.departmentId = this.state.selectedDepartmentId;
		}

		if (this.state.filterDeptArr.length > 1 && this.state.selectedFilterDepartmentName !== departmentFilterDropdownDefaultValue) {
			postParam.copyFromDepartmentId = this.state.selectedFilterDepartmentId;
		}

		fetch(Constants.GetCopyDocumentMasterData, {
			method: "POST",
			mode: "cors",
			body: new URLSearchParams(postParam),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if(handleTokenExpiry(data.responseCode)) return;
				else if (data.responseCode === Constants.CODE_SUCCESS) {
					let targetFilterDeptTemp = [];
					targetFilterDeptTemp = data.data.departments;
					//Filter Dept array
					let filterDeptArr = [];
					let selectedFilterDepartmentId = "-100";
					let selectedFilterDepartmentName = "All";
					if (!isEmptyArray(targetFilterDeptTemp) && targetFilterDeptTemp.length === 1) {
					} else {
						let obj = {
							departmentId: "-100",
							deptName: departmentFilterDropdownDefaultValue,
							isSelected: true,
						};
						filterDeptArr = [...targetFilterDeptTemp];
						filterDeptArr.splice(0, 0, obj);
					}
					this.setState({
						showLoader: false,
						datalist: data.data.result,
						totalCount: data.data.count,
						apiSearchKey: this.state.searchkey,
						showTableFlag: true,
						filterDeptArr: filterDeptArr,
						selectedFilterDepartmentId: selectedFilterDepartmentId,
						selectedFilterDepartmentName: selectedFilterDepartmentName,
					});
				} else {
					this.setState({
						datalist: [],
						showLoader: false,
						totalCount: 0,
						componentDidMountFlag: true,
						apiSearchKey: this.state.searchkey,
					});
				}
			});
	};
	
	getDocumentMastersList = () => {
		this.setState({
			showLoader: true,
			showTableFlag: false,
		});

		let postParam = {
			email: userDetails.email,
			accessToken: userDetails.accessToken,
			pageNo: this.state.currentPageNo,
			search: this.state.searchkey,
			resultsize: this.state.resultSize,
			sortDir: this.state.sortDir,
			sort: this.state.sort,

			//TODO
			status: "Active",
		};

		if (this.state.departmentArr.length > 1 && this.state.selectedDepartmentName !== departmentFilterDropdownDefaultValue) {
			// exclude this department
			postParam.departmentId = this.state.selectedDepartmentId;
		}

		if (this.state.filterDeptArr.length > 1 && this.state.selectedFilterDepartmentName !== departmentFilterDropdownDefaultValue) {
			postParam.copyFromDepartmentId = this.state.selectedFilterDepartmentId;
		}

		fetch(Constants.GetCopyDocumentMasterData, {
			method: "POST",
			mode: "cors",
			body: new URLSearchParams(postParam),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if(handleTokenExpiry(data.responseCode)) return;
				else if (data.responseCode === Constants.CODE_SUCCESS) {
					this.setState({
						showLoader: false,
						datalist: data.data.result,
						totalCount: data.data.count,
						apiSearchKey: this.state.searchkey,
						showTableFlag: true,
					});
				} else {
					this.setState({
						datalist: [],
						showLoader: false,
						totalCount: 0,
						componentDidMountFlag: true,
						apiSearchKey: this.state.searchkey,
					});
				}
			});
	};

	onChangePage = (page) => {
		// update state with new page of items
		if (page !== this.state.currentPageNo) {
			this.setState({
				showLoader: true,
			});

			let postParam = {
				email: userDetails.email,
				accessToken: userDetails.accessToken,
				pageNo: page,
				search: this.state.searchkey,
				resultsize: this.state.resultSize,
				// status: this.state.status,
				// departmentOnly: this.state.deptOnly,
				sort: this.state.sort,
				sortDir: this.state.sortDir,

				status: "Active",		
				};

			if (this.state.departmentArr.length > 1 && this.state.selectedDepartmentName !== departmentFilterDropdownDefaultValue) {
				postParam.departmentId = this.state.selectedDepartmentId;
			}
			if (this.state.filterDeptArr.length > 1 && this.state.selectedFilterDepartmentName !== departmentFilterDropdownDefaultValue) {
				postParam.copyFromDepartmentId = this.state.selectedFilterDepartmentId;
			}

			fetch(Constants.GetCopyDocumentMasterData, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams(postParam),
			})
				.then((response) => {
					return response.json();
				})
				.then((data) => {
					if(handleTokenExpiry(data.responseCode)) return;
					else if (data.responseCode === Constants.CODE_SUCCESS) {
						this.setState({
							showLoader: false,
							datalist: data.data.result,
							totalCount: data.data.count,
							apiSearchKey: this.state.searchkey,
							currentPageNo: page,
						});
					} else {
						this.setState({
							datalist: [],
							showLoader: false,
							apiSearchKey: this.state.searchkey,
						});
					}
				});
		}
	};

	handleCopyDocumentMaster = () => {
		this.setState({
			showLoader: true,
		});

		let isError = false;
		let FormErrorsTemp = {};

		if (isEmptyVariable(this.state.selectedDepartmentName) || this.state.selectedDepartmentName === departmentDropdownDefaultValue) {
			isError = true;
			FormErrorsTemp["deparment"] = "Please select the department";
		}

		if (isEmptyVariable(this.state.selectedId)) {
			isError = true;
			FormErrorsTemp["selectId"] = "Please select the Document";
		}

		if (isError) {
			this.setState({
				formErrors: FormErrorsTemp,
				showLoader: false,
			});
		} else {
			fetch(Constants.CopyDocument, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams({
					email: userDetails.email,
					accessToken: userDetails.accessToken,
					copyFromId: this.state.selectedId,
					departmentId: this.state.selectedDepartmentId,
				}),
			})
				.then((response) => {
					return response.json();
				})
				.then((data) => {
					if(handleTokenExpiry(data.responseCode)) return;
					else if (data.responseCode === Constants.CODE_SUCCESS) {
						this.setState(
							{
								showLoader: false,
							},
							() => {
								this.props.handleCopyDocumentClose();
							}
						);
					} else {
						this.setState({
							showLoader: false,
							showAlertDialogInfo:true,
            				alertDialogMessageInfo:data.responseMessage
						});
					}
				});
		}
	};
	/**************************************************************/

	render() {
		return (
			<section>
				<Modal className="task-select-table-dialog custom-dialog" show={this.props.showCopyDocumentDialog} backdrop="static">
					<Modal.Header>
						<h5>Copy Document</h5>
						<button onClick={this.props.handleCopyDocumentClose} type="button" data-dismiss="modal">
							<span class="material-icons">close</span>
						</button>
					</Modal.Header>
					<hr />
					<div className="modal-body">
						{this.state.showLoader && (
							<div class="loader"></div>
						)}

						{
							// Need to check component did mount flag, other wise until api is called,
							// it shows no items found layout.
							this.state.showDocumentListing && this.state.componentDidMountFlag && (
								<div className="body-wrapper">
									{!isEmptyArray(this.state.departmentArr) && this.state.departmentArr.length > 1 && (
										<div class="addnew-modal-form-group">
											<p>Choose Your Department*</p>
											<RegularDropdown
												placeholder={this.state.selectedDepartmentName}
												dropdownArr={this.state.departmentArr}
												labelParam="name"
												onDropDownItemClick={this.deptDropdownClick}
												defaultPlaceholderDropDown = {departmentDropdownDefaultValue}
											/>
											{!isEmptyVariable(this.state.formErrors["deparment"]) && <span class="cm-error">{this.state.formErrors["deparment"]}</span>}
										</div>
									)}
									{this.state.showTableFlag && (
										<div>
											<div className="search-addnew-bg">
												<div className="search-addnew">
													<div className="search-filter-layout">
														<FilterDropDown
															placeholder={this.state.resultSizePlaceholder}
															dropdownArr={this.state.resultSizeArr}
															onDropDownItemClick={this.resultSizeDropdownClick}
															themeSettings={this.props.themeSettings}
															mleft={0}
														/>
														<div className="search-col m-l-10">
															<input
																name="searchkey"
																type="text"
																onChange={this.handleChangeSearch}
																placeholder="Search"
																onKeyPress={this.onEnterBtnPress}
																value={this.state.searchkey}
															/>
															<SearchSpan
																themeSettings={this.props.themeSettings}
																onClick={this.onSearchIconClick}
																className="material-icons"
															>
																{" "}
																search{" "}
															</SearchSpan>
														</div>

														

														{this.state.filterDeptArr.length > 0 && (
															<FilterDropDown
																placeholder={this.state.selectedFilterDepartmentName}
																dropdownArr={this.state.filterDeptArr}
																onDropDownItemClick={this.deptFilterDropdownClick}
																name={"deptName"}
																themeSettings={this.props.themeSettings}
																dropdownWidth={"120px"}
															/>
														)}
													</div>
												</div>
											</div>
											{!isEmptyArray(this.state.datalist) && (
												<div className="common-tab-bg">
													<div className="common-table" style={{ width: "100%" }}>
														<table className="table">
															<thead>
																<tr>
																	<th className="text-center" width={"8%"}></th>
																	<th className="text-center" width={"5%"}>
																		No
																	</th>
																	<th width={"12%"} className="c-pointer" onClick={this.sortTableLocal.bind(this, sortShortName)}>
																		<div className="sort-header">
																			Short Name
																			<span
																				className={
																					this.state.sort === sortShortName
																						? "material-icons"
																						: "material-icons hide-sort-arrow"
																				}
																			>
																				{this.state.sortDir === "asc" ? "arrow_upward" : "arrow_downward"}
																			</span>
																		</div>
																	</th>
																	<th className="c-pointer" onClick={this.sortTableLocal.bind(this, sortName)}>
																		<div className="sort-header">
																			Name
																			<span
																				className={
																					this.state.sort === sortName ? "material-icons" : "material-icons hide-sort-arrow"
																				}
																			>
																				{this.state.sortDir === "asc" ? "arrow_upward" : "arrow_downward"}
																			</span>
																		</div>
																	</th>
																	<th className="c-pointer" onClick={this.sortTableLocal.bind(this, sortDescription)}>
																		<div className="sort-header">
																			Description
																			<span
																				className={
																					this.state.sort === sortDescription
																						? "material-icons"
																						: "material-icons hide-sort-arrow"
																				}
																			>
																				{this.state.sortDir === "asc" ? "arrow_upward" : "arrow_downward"}
																			</span>
																		</div>
																	</th>

																	<th width={"14%"} className="c-pointer" onClick={this.sortTableLocal.bind(this, sortDeptName)}>
																		<div className="sort-header">
																			Department
																			<span
																				className={
																					this.state.sort === sortDeptName ? "material-icons" : "material-icons hide-sort-arrow"
																				}
																			>
																				{this.state.sortDir === "asc" ? "arrow_upward" : "arrow_downward"}
																			</span>
																		</div>
																	</th>
																	{
                                                                        this.props.subscription?.docErp == "Y" && (
																		<th className="text-center" width={"5%"}>
																			ERP
																		</th>
																	)}
																	<th className="text-center" width={"10%"}>
																		Samples
																	</th>
																</tr>
															</thead>
															<tbody>
																{!isEmptyArray(this.state.datalist) &&
																	this.state.datalist.map((item, idx) => {
																		return (
																			<tr onClick={this.handleDetailsDialogShow.bind(this, item)}>
																				<td>
																					<TableCheckBox onClick={this.handleStopPropagation} themeSettings={this.props.themeSettings}>
																						<input
																							type="checkbox"
																							name={idx}
																							id={item.documentId}
																							onChange={this.handleSelection}
																							checked={this.state.selectedId === item.documentId ? true : false}
																						/>
																						<label for={item.documentId} style={{ marginLeft: 6 }}></label>
																					</TableCheckBox>
																				</td>
																				<td className="text-center">
																					{(this.state.currentPageNo - 1) * this.state.resultSize + ++idx}
																				</td>
																				<td>{item.shortName}</td>
																				<td>{item.name}</td>
																				<td>{truncateString(item.description, Constants.OTHERMASTERS_STRING_LENGTH)}</td>
																				<td>{item.departmentName}</td>
																				{
                                                                                    this.props.subscription?.docErp == "Y" && (
																					<TableIcon themeSettings={this.props.themeSettings} className="text-center">
																						<span
																							class="material-icons"
																							onClick={this.handleShowDocumentERPListing.bind(this, item)}
																						>
																							visibility
																						</span>
																					</TableIcon>
																				)}
																				<TableIcon themeSettings={this.props.themeSettings} className="text-center">
																					<span
																						class="material-icons"
																						onClick={this.handleShowDocumentSamplesListing.bind(this, item)}
																					>
																						topic
																					</span>
																				</TableIcon>
																			</tr>
																		);
																	})}
															</tbody>
														</table>
													</div>
												</div>
											)}
											{!isEmptyVariable(this.state.formErrors["selectId"]) && <span class="cm-error">{this.state.formErrors["selectId"]}</span>}

											{this.state.componentDidMountFlag && isEmptyArray(this.state.datalist) && (
												<div class="no-items-layout">
													<div class="no-items-card">
														<h6>
															{isEmptyVariable(this.state.apiSearchKey) ? Constants.NO_RECORDS_WARNING : Constants.EMPTY_SEARCH_WARNING}
														</h6>
													</div>
												</div>
											)}
											<div className="pagination-layout">
												<div className="row custom-row">
													<div className="col-md-9 custom-col">
														{this.state.totalCount > this.state.datalist.length && (
															<Pagination
																totalLength={this.state.totalCount}
																items={this.state.datalist}
																onChangePage={this.onChangePage}
																pageSize={this.state.resultSize}
																currentPageNo={this.state.currentPageNo}
																initialPage={this.state.currentPageNo}
																themeSettings={this.props.themeSettings}
															/>
														)}
													</div>
													<div className="col-md-3 custom-col">
														<p>{"Total Records: " + this.state.totalCount}</p>
													</div>
												</div>
											</div>
										</div>
									)}
									{/* <div class="addnew-modal-form-group">
										{!isEmptyVariable(this.state.formErrors["apiErr"]) && <span class="cm-error">{this.state.formErrors["apiErr"]}</span>}
									</div> */}
									<div class="modal-close-save">
										<div class="close-save-col">
											<button onClick={this.props.handleCopyDocumentClose} type="button" class="modal-close">
												Cancel
											</button>
											<DialogSaveButton themeSettings={this.props.themeSettings} onClick={this.handleCopyDocumentMaster} type="button">
												Save
											</DialogSaveButton>
										</div>
									</div>
								</div>
							)
						}
						{this.state.showDocumentSamplesListing && (
							<DocumentSamplesListLayout
								documentId={this.state.selectedDocumentId}
								documentName={this.state.selectedDocumentName}
								handleBackBtnClickFromSamplesandERP={this.handleBackBtnClickFromSamplesandERP}
								themeSettings={this.props.themeSettings}
							/>
						)}
						{this.state.showDocumentERPListing && (
							<DocumentERPListLayout
								documentId={this.state.selectedDocumentId}
								documentName={this.state.selectedDocumentName}
								handleBackBtnClickFromSamplesandERP={this.handleBackBtnClickFromSamplesandERP}
								themeSettings={this.props.themeSettings}
							/>
						)}
						<AlertDialog
							showAlertDialog={this.state.showAlertDialogInfo}
							handleAlertDialogClose={this.handleAlertDialogCloseInfo}
							type={Constants.ALERT_TYPE_ALERT}
							alertDialogMessage={this.state.alertDialogMessageInfo}
							proceedBtnClick={this.handleAlertDialogCloseInfo}
							proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
							themeSettings={this.props.themeSettings}
						/>
					</div>
				</Modal>
				<Modal className="custom-dialog" show={this.state.showDetailsDialog} onHide={this.handleDetailsDialogClose}>
					<Modal.Header>
						<h5>{this.state.selectedItem.shortName}</h5>
						<button onClick={this.handleDetailsDialogClose} type="button" data-dismiss="modal">
							<span class="material-icons">close</span>
						</button>
					</Modal.Header>
					<hr />
					<div class="modal-body">
						<div className="details-table-layout">
							<div className="row custom-row">
								<div className="col-md-12 custom-col">
									<table>
										<tbody>
											<tr>
												<td width={"24%"}>Short Name</td>
												<td width={"4%"}>:</td>
												<td width={"72%"}>{this.state.selectedItem.shortName}</td>
											</tr>
											<tr>
												<td width={"24%"}>Name</td>
												<td width={"4%"}>:</td>
												<td width={"72%"}>{this.state.selectedItem.name}</td>
											</tr>
											<tr>
												<td width={"24%"}>Function</td>
												<td width={"4%"}>:</td>
												<td width={"72%"}>{this.state.selectedItem.functionName}</td>
											</tr>
											<tr>
												<td width={"24%"}>Description</td>
												<td width={"4%"}>:</td>
												<td width={"72%"}>{ifEmptyReturnEmptyStr(this.state.selectedItem.description, "-")}</td>
											</tr>
											<tr>
												<td width={"24%"}>Department</td>
												<td width={"4%"}>:</td>
												<td width={"72%"}>{this.state.selectedItem.departmentName}</td>
											</tr>
											{this.state.selectedItem.status !== activeStatus && this.state.selectedItem.status !== inActiveStatus && (
												<tr>
													<td width={"24%"}>Review Status</td>
													<td width={"4%"}>:</td>
													<td width={"72%"}>{this.state.selectedItem.currentReviewStatus}</td>
												</tr>
											)}
											{this.state.selectedItem.allowReview === Constants.ALLOW_REVIEW_SUBMITREVIEW &&
												this.state.selectedItem.currentReviewStatus.includes(requestChangeCheckText) && (
													<tr>
														<td width={"24%"}>Review Remarks</td>
														<td width={"4%"}>:</td>
														<td width={"72%"}>{this.state.selectedItem.lastReviewRemark}</td>
													</tr>
												)}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</Modal>
			</section>
		);
	}
}
export default DocumentSampleList;
